import { Card } from "@/components/ui/card";
import { FileText } from "lucide-react";
import "../styles/DataTable.css";

export function DataTable<T>({
  title = "Table",
  subtitle,
  data,
  columns,
}: {
  title?: string;
  subtitle?: string;
  data: T[];
  columns: {
    key: keyof T | string;
    header: string;
    render?: (value: any, row: T) => React.ReactNode;
    className?: string;
  }[];
}) {
  return (
    <div className="w-full flex flex-col items-center px-4">
      {/* Page Header */}
      <div className="page-header">
        <h1 className="page-title">{title}</h1>
          {subtitle && <p className="page-subtitle">{subtitle}</p>}
      </div>

      {/* Table Card */}
      <Card className="w-full max-w-[1216px] rounded-xl shadow-sm bg-white border border-neutral-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            {/* Sticky Header */}
            <thead className="bg-neutral-50 border-b border-neutral-200 sticky top-0 z-10">
              <tr>
                {columns.map((col) => (
                  <th
                    key={String(col.key)}
                    className={`
                      px-6 py-3.5
                      text-xs font-semibold tracking-wider
                      text-neutral-700 uppercase 
                      whitespace-nowrap
                      text-left
                      ${col.className || ""}
                    `}
                  >
                    {col.header}
                  </th>
                ))}
              </tr>
            </thead>

            {/* Table Body */}
            <tbody>
              {data.length > 0 ? (
                data.map((row, idx) => (
                  <tr
                    key={idx}
                    className="border-b border-neutral-100 hover:bg-[#F8FAFC] transition-colors"
                  >
                    {columns.map((col) => (
                      <td
                        key={String(col.key)}
                        className={`
                          px-6 py-3.5 
                          text-sm
                          whitespace-nowrap
                          ${col.className || ""}
                        `}
                      >
                        {col.render
                          ? col.render((row as any)[col.key], row)
                          : (row as any)[col.key]}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columns.length} className="py-20">
                    <div className="flex flex-col items-center">
                      <FileText className="w-10 h-10 text-neutral-400 mb-3" />
                      <h3 className="text-lg font-medium text-neutral-700">
                        No exam history yet
                      </h3>
                      <p className="text-sm text-neutral-500">
                        Your exam results will appear here after your first attempt.
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Card>

      {/* Bottom spacing */}
      <div className="mb-24" />
    </div>
  );
}
